import { createAction, props } from '@ngrx/store';
import { IBillingBalance } from '@dch/billing-business-logic';

export const GET_BILLING_BALANCE_REQUEST = 'GET_BILLING_BALANCE_REQUEST';
export const GET_BILLING_BALANCE_SUCCESS = 'GET_BILLING_BALANCE_SUCCESS';
export const GET_BILLING_BALANCE_FAILURE = 'GET_BILLING_BALANCE_FAILURE';

export const SET_SELECTED_BILLING_ACCOUNT = 'SET_SELECTED_BILLING_ACCOUNT';

export const getBillingBalanceRequest = createAction(
  GET_BILLING_BALANCE_REQUEST
);

export const getBillingBalanceSuccess = createAction(
  GET_BILLING_BALANCE_SUCCESS,
  props<{ billingBalance: IBillingBalance }>()
);

export const getBillingBalanceFailure = createAction(
  GET_BILLING_BALANCE_FAILURE,
  props<{ errorCode?: string }>()
);

export const setSelectedBillingAccount = createAction(
  SET_SELECTED_BILLING_ACCOUNT,
  props<{ billingAccountNumber?: string }>()
);
